<div class="ion-page">

  <dd-modal-header [title]="'Deal'"></dd-modal-header>

  <ion-content>

    <div class="ion-content ion-padding modal-content">
      <dd-deal-form [id]="id"
                    [personId]="personId"
                    [organizationId]="organizationId"
                    [sourceObject]="sourceObject"
                    (update)="close()"
                    (create)="closeAndNavigate($event)"
                    (delete)="close()"></dd-deal-form>
    </div>

  </ion-content>

</div>

